import { render } from "./CreateEditRole.vue?vue&type=template&id=35b8b9ce&scoped=true"
import script from "./CreateEditRole.vue?vue&type=script&lang=js"
export * from "./CreateEditRole.vue?vue&type=script&lang=js"

import "./CreateEditRole.vue?vue&type=style&index=0&id=35b8b9ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b8b9ce"]])

export default __exports__